import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import { media } from "@src/common/styles/mixins";
import {
  ModalTransitionProps,
  MODAL_TRANSITION_TIME_MS,
} from "@src/modules/shared/components/Modal/ModalContainer.components";

const MODAL_BORDER_RADIUS = 12;

export type BaseModalWrapperProps = ModalTransitionProps;

const BaseModalWrapper = styled.div<BaseModalWrapperProps>`
  background-color: ${colors.background};
  transition: all ${MODAL_TRANSITION_TIME_MS}ms ease-in-out;
  transform: translate(0, -50px);

  border-radius: ${MODAL_BORDER_RADIUS}px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);

  max-height: 100%;

  ${media.down("MOBILE")`
    transform: none;
    opacity: 0;
  `}

  ${(p) =>
    (p.status === "entering" || p.status === "entered") &&
    css`
      transform: translate(0, 0);
      ${media.down("MOBILE")`
        transform: none;
        opacity: 1;
      `}
    `};
`;

export default BaseModalWrapper;
